/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from 'react';
import { useInitial } from 'hooks';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBGLoaded,
  getErrorNovell,
  getGlobal,
  getLoadedNovell,
  getPersonsLoaded,
  getSoundLoaded,
  loadNovell,
} from 'store';
import { Styles } from 'Styles';
import Scene from 'containers/Scene';

interface Props {
  width: string;
  height: string;
}

function App(props: Props) {
  useInitial(parseInt(props.width, 10), parseInt(props.height, 10));
  const dispatch = useDispatch();
  const [play, setPlay] = useState(false);
  const isPersonsLoaded = useSelector(getPersonsLoaded);
  const isBGLoaded = useSelector(getBGLoaded);
  const isSoundLoaded = useSelector(getSoundLoaded);

  const { height, width } = useSelector(getGlobal);
  const loadedNovell = useSelector(getLoadedNovell);
  const error = useSelector(getErrorNovell);

  useEffect(() => {
    dispatch(loadNovell());
  }, []);

  if (error) {
    return null;
  }

  return loadedNovell ? (
    <>
      <Styles />
      <div
        className="container"
        onClick={() => {
          if (isPersonsLoaded && isBGLoaded && isSoundLoaded) setPlay(true);
        }}
      >
        {play ? null : (
          <div
            className="overlapBlock"
            style={{
              height,
              width,
            }}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <button type="button" className="playBtn">
              Click to play
            </button>
          </div>
        )}
        <Scene play={play} />
      </div>
    </>
  ) : null;
}

export default App;
